import { render, staticRenderFns } from "./ChatbotConversationModal.vue?vue&type=template&id=70e8b36a&scoped=true"
import script from "./ChatbotConversationModal.vue?vue&type=script&lang=js"
export * from "./ChatbotConversationModal.vue?vue&type=script&lang=js"
import style0 from "./ChatbotConversationModal.vue?vue&type=style&index=0&id=70e8b36a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e8b36a",
  null
  
)

export default component.exports